import { CommonPath, KoreanLanguagePath } from 'Constants/Navigation'
import { MainLayout } from 'Components/Layouts'
import { Navigate } from 'react-router-dom'
import { SuspenseUI } from 'Components/UI'
import { KoreanLanguagePage, KoreanLanguageAddPage, KoreanLanguageEditPage } from 'Views/KoreanLanguage'

export const koreanLanguageRoutes = {
  path: '',
  children: [
    {
      path: `/${KoreanLanguagePath.main}`,
      element: <MainLayout />,
      children: [
        {
          path: '',
          element: <Navigate to={`/${KoreanLanguagePath.main}/${KoreanLanguagePath.statistics}`} />,
        },
        {
          path: KoreanLanguagePath.statistics,
          children: [
            {
              path: '',
              element: (
                <SuspenseUI>
                  <KoreanLanguagePage />
                </SuspenseUI>
              ),
            },
            {
              path: CommonPath.add,
              element: (
                <SuspenseUI>
                  <KoreanLanguageAddPage />
                </SuspenseUI>
              ),
            },
          ],
        },
        {
          path: KoreanLanguagePath.support,
          children: [
            {
              path: '',
              element: (
                <SuspenseUI>
                  <KoreanLanguagePage />
                </SuspenseUI>
              ),
            },
            {
              path: CommonPath.add,
              element: (
                <SuspenseUI>
                  <KoreanLanguageAddPage />
                </SuspenseUI>
              ),
            },
          ],
        },
        {
          path: KoreanLanguagePath.activity,
          children: [
            {
              path: '',
              element: (
                <SuspenseUI>
                  <KoreanLanguagePage />
                </SuspenseUI>
              ),
            },
            {
              path: CommonPath.add,
              element: (
                <SuspenseUI>
                  <KoreanLanguageAddPage />
                </SuspenseUI>
              ),
            },
          ],
        },
        {
          path: KoreanLanguagePath.exemplary,
          children: [
            {
              path: '',
              element: (
                <SuspenseUI>
                  <KoreanLanguagePage />
                </SuspenseUI>
              ),
            },
            {
              path: CommonPath.add,
              element: (
                <SuspenseUI>
                  <KoreanLanguageAddPage />
                </SuspenseUI>
              ),
            },
          ],
        },
      ],
    },
    // Edit routes for each section
    {
      path: `/${KoreanLanguagePath.main}/${KoreanLanguagePath.statistics}/edit/:koreanLanguageId`,
      element: <MainLayout noWrapper />,
      children: [
        {
          path: '',
          element: (
            <SuspenseUI>
              <KoreanLanguageEditPage />
            </SuspenseUI>
          ),
        },
      ],
    },
    {
      path: `/${KoreanLanguagePath.main}/${KoreanLanguagePath.support}/edit/:koreanLanguageId`,
      element: <MainLayout noWrapper />,
      children: [
        {
          path: '',
          element: (
            <SuspenseUI>
              <KoreanLanguageEditPage />
            </SuspenseUI>
          ),
        },
      ],
    },
    {
      path: `/${KoreanLanguagePath.main}/${KoreanLanguagePath.activity}/edit/:koreanLanguageId`,
      element: <MainLayout noWrapper />,
      children: [
        {
          path: '',
          element: (
            <SuspenseUI>
              <KoreanLanguageEditPage />
            </SuspenseUI>
          ),
        },
      ],
    },
    {
      path: `/${KoreanLanguagePath.main}/${KoreanLanguagePath.exemplary}/edit/:koreanLanguageId`,
      element: <MainLayout noWrapper />,
      children: [
        {
          path: '',
          element: (
            <SuspenseUI>
              <KoreanLanguageEditPage />
            </SuspenseUI>
          ),
        },
      ],
    },
  ],
}
